import { useMadSDKList, useMadSDKSingular } from "../../madSDK";
import { madSDK } from "../../../sdk";
import { useAgentSessionId } from "./sessionIds";
import { useSingularMadHooksUtils } from "../../madSDK/singular/singularUtils";
/**
 * Hook for managing ai agent session data.
 *
 * **When to use:**
 * - Fetching/refreshing session data (typically used internally for hooks like: `useAgentChat`)
 *
 * @param agent The name of the AI agent. {@link AgentName}
 * @param sessionId The ID of the agent session.
 * @param options Options for managing the agent session.
 * @returns {SingularAgentSessionData}
 */
export const useAgentSession = (agent, sessionId, options = {}) => {
    const sessionIds = useAgentSessionId(agent, sessionId, options);
    const session = useMadSDKSingular(madSDK.ai.agents[agent], sessionIds?.data?.id, options);
    const { observer: sessionObserver } = useSingularMadHooksUtils(madSDK.ai.agents[agent], sessionIds?.data?.id);
    return {
        ...session,
        newSession: sessionIds.newSession,
        withEnsuredSession: sessionIds.withEnsuredSession,
        isLoading: sessionIds.isLoading || session.isLoading,
        isInitializing: sessionIds.isInitializing || session.isInitializing,
        isLoaded: sessionIds.isLoaded && session.isLoaded,
        error: sessionIds.error || session.error,
        isCreatingSession: !!sessionIds.isSaving,
        sessionObserver
    };
};
/**
 * Hook that returns a list of all agent sessions
 */
export const useAgentSessionsLists = (agent, options) => useMadSDKList(madSDK.ai.agents[agent].lists, options);
//# sourceMappingURL=sessions.js.map